export default "__VITE_ASSET__9db389d3__"